/**
 * Utility Modules Index
 * Central exports for all utility modules
 */

import cacheManager from './cacheManager.js';
import publicAuthService from './publicAuth.js';
import TouchGestureManager from './touchGestures.js';
import MobileAccessibilityManager from './mobileAccessibility.js';
import DateUtil from './dateUtil.js';
import themeManager from './themeManager.js';
import memoryLeakPrevention from './memoryLeakPrevention.js';
import componentLifecycleManager from './componentLifecycleManager.js';

// Export utilities
export {
  cacheManager,
  publicAuthService,
  TouchGestureManager,
  MobileAccessibilityManager,
  DateUtil,
  themeManager,
  memoryLeakPrevention,
  componentLifecycleManager
};

// Make utilities available globally for backward compatibility
if (typeof window !== 'undefined') {
  window.cacheManager = cacheManager;
  window.DateUtil = DateUtil;
  window.themeManager = themeManager;
  window.memoryLeakPrevention = memoryLeakPrevention;
  window.componentLifecycleManager = componentLifecycleManager;
}

/**
 * Usage Examples:
 * 
 * // Using cache manager in components:
 * import { cacheManager } from '../utils/index.js';
 * 
 * // Or use global reference:
 * window.cacheManager.set('user_data', userData, 'user', 10*60*1000); // 10 minutes
 * 
 * // Cache namespaces for different data types:
 * - 'organizations' - Organization data
 * - 'users' - User data  
 * - 'appointments' - Appointment data
 * - 'services' - Service data
 * - 'ui' - UI state and preferences
 */
